import { Component, OnInit, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'gf-video-modal',
  template: require('./video-modal.component.html')
})
export class VideoModalComponent implements OnInit {

  @Input() file: any;
  @Input() url: any;
  @Input() close: any; // Ensure you adjust this binding based on how you intend to use it in Angular
  
  constructor(private el: ElementRef) { }

  ngOnInit() {
  }
}
